import { cn } from '@/lib/utils';

// molecule — DWR aspetti pill toggle. Pattern .aspetti-pill mockup
// (styles.css 1343-1355). aria-pressed: bg ink + text paper-bright + border ink.
// near-duplicate of future <Pill variant> generico: emergerà quando in PR 5-7
// si toccano tag pills, filtri categorici, ecc. Per ora molecule dedicata
// a SectionAspetti (~12-20 istanze totali a seconda della classe scelta).

interface AspettoPillProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  className?: string;
}

export function AspettoPill({ label, selected, onClick, className }: AspettoPillProps) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      className={cn(
        'border-rule bg-paper-bright text-ink font-serif cursor-pointer border px-[0.85em] py-[0.35em] text-[0.88rem] whitespace-nowrap transition-colors duration-150',
        'hover:border-ink',
        selected && 'border-ink bg-ink text-paper-bright',
        className,
      )}
    >
      {label}
    </button>
  );
}
